import { render, staticRenderFns } from "./EbookCard.vue?vue&type=template&id=0a0e89f8&scoped=true"
import script from "./EbookCard.vue?vue&type=script&lang=js"
export * from "./EbookCard.vue?vue&type=script&lang=js"
import style0 from "./EbookCard.vue?vue&type=style&index=0&id=0a0e89f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0e89f8",
  null
  
)

export default component.exports